import { Spinner } from "reactstrap";
import "./styles.css";
import { useContext, useEffect } from "react";
import { Context } from "../../hooks/useAuthContext";

function FullScreenLoader() {
  const { logout } = useContext(Context);

  useEffect(() => {
    const timer = setTimeout(() => {
      logout(); // chama o logout após 10 segundos
    }, 15000); // 15 segundos = 15000 ms

    return () => clearTimeout(timer); // limpa o timer se o componente for desmontado
  }, [logout]);

  return (
    <div className="fullscreen-loader">
      <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
    </div>
  );
}

export default FullScreenLoader;
